export default {
	perClick: {
		name: "Per Click",
		description: "The amount of money you earn per click on average.",
		default: 5,
		displayValue: "Each click gives on average %VALUEASMONEY",
	},
	perClickMul: {
		name: "Per Click Multiplier",
		description: "",
		default: 1,
		displayValue: "",
	},
	passiveIncome: {
		name: "Passive Income",
		desc: "Slowly earn money while having the game open.",
		default: 0,
		displayValue: "[[ ... ]]",
	},
	offlineRate: {
		name: "Offline Income Rate",
		desc: "Earn a little while offline.",
		default: 0,
		displayValue: "Currently earning %VALUEASMONEY while being offline.",
	},
	offlineTime: {
		name: "Offline Income Time",
		desc: "The maximum amount of time you can be offline while earning offline income. Simply log in to reset this timer.",
		default: 0,
		displayValue: "You can currently be offline for %VALUE minutes, while earning offline income.",
	},
	shopDiscount: {
		name: "Shop Discount",
		desc: "A permanent discount for all items in the shop.",
		default: 0,
		displayValue: "All items in the shop are discounted %VALUE%",
	},
	missionGeneration: {
		name: "New Mission Assignment Speed",
		desc: "The time delay before getting a new mission, once you complete or discard a mission.",
		default: 240,
		displayValue: "It currently takes %VALUE minutes before a new mission is received.",
	},
	missionSlots: {
		name: "Mission Slots",
		desc: "The amount of missions you can have.",
		default: 3,
		displayValue: "You have %VALUE mission slots",
	},
	missionRewards: {
		name: "Mission Rewards Buff",
		desc: "",
		default: 1,
		displayValue: "",
	},
	clickEffectsChance: { name: "", desc: "", default: 1, displayValue: "" },
	clickEffectsDecay: { name: "", desc: "", default: 1, displayValue: "" },
	clickEffectsDuration: { name: "", desc: "", default: 1, displayValue: "" },
	effectCashBag: { name: "", desc: "", default: 0, displayValue: "" },
	xpmul: { name: "XP Multiplier", desc: "", default: 1, displayValue: "" },
	xpMulMul: { name: "XP Multiplier", desc: "", default: 1, displayValue: "" },
	perClickXp: {
		name: "Clicking XP Multiplier",
		desc: "",
		default: 1,
		displayValue: "",
	},
	maxbet: {
		name: "Maximum Bet Value",
		desc: "",
		default: 5e4,
		displayValue: "",
	},
	shopBuy: {
		name: "Maximum buy amount at once",
		desc: "",
		default: 25,
		displayValue: "",
	},
	unlockCollections: {
		name: "Unlock Collections",
		desc: "",
		default: 0,
		displayValue: "",
	},
	unlockStickers: {
		name: "Unlock Stickers",
		desc: "",
		default: 0,
		displayValue: "",
	},
	unlockClickEffect2x: {
		name: "Unlock Click Effect: 2X",
		desc: "",
		default: 0,
		displayValue: "",
	},
	unlockClickEffect4x: {
		name: "Unlock Click Effect: 4X",
		desc: "",
		default: 0,
		displayValue: "",
	},
	unlockClickEffect7x: {
		name: "Unlock Click Effect: 7X",
		desc: "",
		default: 0,
		displayValue: "",
	},
	instantOpen: {
		name: "Instant Case Opening",
		desc: "Open cases instantly for a small fee.",
		default: null, //TODO: this is a hack
		displayValue: "",
	},
} as const;
